import { useMemo } from "react";
import { useAvailableDates } from "api/hooks";
import { format, isBefore, isSameDay, isValid, parseISO } from "date-fns";
import { useSearchParams } from "react-router-dom";
import { Calendar } from "theme";

const parseStringDate = (dateString: string): Date => {
  const ISODate = new Date(dateString).toISOString();
  return parseISO(ISODate);
};

export const convertStingToDate = (value: string | null) => {
  if (!value) return null;
  const date = parseStringDate(value);

  if (!isValid(date) || (isBefore(date, new Date()) && !isSameDay(date, new Date()))) {
    return null;
  }

  return date;
};

const ControlledCalendar = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentDate = useMemo(() => {
    return convertStingToDate(searchParams.get("d")) ?? new Date();
  }, [searchParams]);

  const { availableDates, isFetching } = useAvailableDates({
    hallId: searchParams.get("h"),
  });

  return (
    <Calendar
      availableDates={!isFetching ? availableDates.map((el) => el.availableDate) : undefined}
      onChange={(date) => {
        setSearchParams((prev) => {
          prev.set("d", date ? format(date, "yyyy-MM-dd") : "");

          return prev;
        });
      }}
      value={currentDate}
    />
  );
};

export default ControlledCalendar;
